export function servicesFunc() {
	let servicesTop = $("#servicesTop").length;

	if(servicesTop){
		subNavHeightFunc();

		subNavAccordionFuc();

		subNavScrollFunc();

		function subNavHeightFunc(){
			let subNavHeight = $(".subNav");
			let headerHeight = $("#header").outerHeight();
			subNavHeight.css("top" , `${headerHeight}px`);
			
			let setTimer = false;
			$(window).on('resize', function () {
				if (setTimer !== false) {
					clearTimeout(setTimer);
				  }
				  setTimer = setTimeout(() => {
					subNavHeightFunc();
				  }, 200);
			});
			
		}
		

		function subNavAccordionFuc(){
			const servicesSubNavAccordionBtn = $('#servicesSubNav .accordionBtn');
			const servicesSubNav = $('#servicesSubNavList a');
			let resizecheck = $('#responsibleCheck').width();
			let resizecheck2 = 0;
		  
			$(window).on('load resize', function () {
			  resizecheck = $('#responsibleCheck').width();
			  subNavAccordionMenuStart();
			  subNavCloseFunc();
			});
	
			//スマホのみサブナビをクリックでクローズさせる
			function subNavCloseFunc() {
				if (resizecheck == '2') {
				  servicesSubNav.on('click', subNavClickHandler);
				} else if (resizecheck == '1') {
				  servicesSubNav.off('click', subNavClickHandler);
				}
			  }
			  function subNavClickHandler() {
				servicesSubNavAccordionBtn.next('dd').slideUp(500);
				servicesSubNavAccordionBtn.removeClass('isOpen');
			  }
			  subNavCloseFunc()
	
			servicesSubNavAccordionBtn.on('click', function () {
			  if (resizecheck == '2') {
				if ($(this).hasClass('isOpen')) {
					$(this).next('dd').slideUp(500);
					$(this).removeClass('isOpen');
				} else {
					servicesSubNavAccordionBtn.next('dd').slideUp(500);
					servicesSubNavAccordionBtn.removeClass('isOpen');
					$(this).next('dd').slideDown(500);
					$(this).addClass('isOpen');
				}
			  }
			}); 
			
			var subNavAccordionMenuStart = function () {
				let resizecheck = $('#responsibleCheck').width();
				if (resizecheck == '2' && resizecheck != resizecheck2) {
					servicesSubNavAccordionBtn.next('dd').css('display', 'none');
					resizecheck2 = 2;
				} else if (resizecheck == '1' && resizecheck != resizecheck2) {
					servicesSubNavAccordionBtn.removeClass('isOpen');
					servicesSubNavAccordionBtn.next('dd').css('display', 'block');
					resizecheck2 = 1;
				}
			}
			subNavAccordionMenuStart();
		}

		function subNavScrollFunc(){
			// 今回の交差を監視する要素
			const boxes = document.querySelectorAll(".servicesList .list");

			const options = {
				root: null,
				rootMargin: "-50% 0px -50%",
				threshold: 0
			};
			const observer = new IntersectionObserver(doWhenIntersect, options);
			boxes.forEach(box => {
				observer.observe(box);
			});

			/**
			 * 交差したときに呼び出す関数
			 * @param entries
			 */
			function doWhenIntersect(entries) {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						activateIndex(entry.target);
					}
				});
			}
			/**
			 * 目次を変える関数
			 * @param element
			 */
			function activateIndex(element) {
				const currentActiveIndex = document.querySelector("#servicesSubNavList .active");
				if (currentActiveIndex !== null) {
					currentActiveIndex.classList.remove("active");
				}
				const newActiveIndex = document.querySelector(`a[href='#${element.id}']`).parentElement;
				newActiveIndex.classList.add("active");

				const currentTxt = document.querySelector(`a[href='#${element.id}']`).textContent
				$("#navCurrent").text(currentTxt).css({"color":"#004092"})
			}
		}

		$(window).on('load scroll', function () {
			var subNavCurrent = $("#servicesSubNavList .pageLinkList")
			var scroll = $(window).scrollTop();
			if(scroll == 0){
				$("#navCurrent").text("Service Lineup").css({"color":"#121212"})
				if (subNavCurrent.hasClass('active')) {
					subNavCurrent.removeClass("active")
				  }
			}
		});
	}
}